module.exports = __webpack_public_path__ + "img/draw-pointer.249790d4.png";